export default __webpack_public_path__ + "static/media/Yellow0000.cfabcaa7.png";